import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { AuthenticationHelper } from '../../../helpers/authenticationHelper';
import { UtilityHelper } from '../../../helpers/utilityHelper';
import { OnboardingProgressService } from '../services/onboarding-progress.service';

/**
 * Legacy /feeds is the home for non-automation projects only.
 * When automation is enabled, send the user into the gamification landing
 * (welcome, matching, or home) instead of rendering FeedsComponent.
 */
export const FeedsToGamificationGuard: CanActivateFn = () => {
    const authService = inject(AuthenticationHelper);
    const onboarding = inject(OnboardingProgressService);
    const utility = inject(UtilityHelper);
    const router = inject(Router);

    if (!authService.isLoggedIn()) {
        return router.createUrlTree(['sign-in']);
    }

    const role = onboarding.role() || utility.getItem('role') || '';
    if (role === 'admin' || role === 'coordinator') {
        return true;
    }

    if (utility.getItem('automation_enabled') === 'false') {
        return true;
    }

    return onboarding.ensureSession().pipe(
        map(ok => {
            if (!ok) {
                return router.createUrlTree(['sign-in']);
            }
            const sessionRole = onboarding.role() || utility.getItem('role') || '';
            if (sessionRole === 'admin' || sessionRole === 'coordinator') {
                return true;
            }
            if (onboarding.isGamificationMode()) {
                return router.createUrlTree(onboarding.landingRoute());
            }
            return true;
        }),
    );
};
